export default __webpack_public_path__ + "static/media/planta-h-2.a9f83528.jpg";